import VoterForm from "./VoterForm";

export default VoterForm;